module.exports = __webpack_public_path__ + "img/arctic-lodge.75b58089.webp";